import React, { useState } from 'react';
import { motion } from 'framer-motion';
export function Contact() {
  const [formState, setFormState] = useState<'idle' | 'submitting' | 'success'>('idle');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setFormState('submitting');
    // Simulate API call
    setTimeout(() => {
      setFormState('success');
    }, 1500);
  };
  return <section id="contact" className="py-24 md:py-32 bg-cream" data-id="element-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-33">
        <div className="bg-ink text-cream rounded-2xl md:rounded-[2.5rem] p-8 md:p-16 lg:p-24 overflow-hidden relative" data-id="element-34">
          {/* Decorative background element */}
          <div className="absolute top-0 right-0 w-96 h-96 bg-accent/20 rounded-full blur-[100px] -translate-y-1/2 translate-x-1/3" data-id="element-35" />

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 relative z-10" data-id="element-36">
            <div data-id="element-37">
              <h2 className="text-5xl md:text-7xl font-serif tracking-tight mb-6" data-id="element-38">
                Let's create <br data-id="element-39" />
                <span className="italic text-accent" data-id="element-40">something</span> together.
              </h2>
              <p className="text-cream/70 text-lg mb-12 max-w-md" data-id="element-41">
                Currently accepting new projects for Q3. Fill out the form or
                drop me an email directly to discuss your needs.
              </p>

              <div className="space-y-6" data-id="element-42">
                <div data-id="element-43">
                  <p className="text-sm text-cream/50 uppercase tracking-wider mb-2" data-id="element-44">
                    Email
                  </p>
                  <a href="mailto:marilyn.peixoto@gmail.com" className="text-xl font-medium hover:text-accent transition-colors" data-id="element-45">
                    marilyn.peixoto@gmail.com
                  </a>
                </div>
                <div data-id="element-46">
                  <p className="text-sm text-cream/50 uppercase tracking-wider mb-2" data-id="element-47">
                    Location
                  </p>
                  <p className="text-xl font-medium" data-id="element-48">California, USA (PT)</p>
                </div>
              </div>
            </div>

            <div className="bg-cream/5 backdrop-blur-sm border border-cream/10 p-8 rounded-xl" data-id="element-49">
              {formState === 'success' ? <motion.div initial={{
              opacity: 0,
              scale: 0.95
            }} animate={{
              opacity: 1,
              scale: 1
            }} className="h-full flex flex-col items-center justify-center text-center py-12" data-id="element-50">
                  <div className="w-16 h-16 bg-accent/20 text-accent rounded-full flex items-center justify-center mb-6" data-id="element-51">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-52">
                      <polyline points="20 6 9 17 4 12" data-id="element-53"></polyline>
                    </svg>
                  </div>
                  <h3 className="text-3xl font-serif mb-4" data-id="element-54">Message Sent</h3>
                  <p className="text-cream/70" data-id="element-55">
                    Thank you for reaching out. I'll get back to you within
                    24-48 hours.
                  </p>
                  <button onClick={() => setFormState('idle')} className="mt-8 text-sm font-medium text-accent hover:text-white transition-colors border-b border-accent hover:border-white pb-1" data-id="element-56">
                    Send another message
                  </button>
                </motion.div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-57">
                  <div data-id="element-58">
                    <label htmlFor="name" className="block text-sm font-medium text-cream/70 mb-2" data-id="element-59">
                      Name
                    </label>
                    <input type="text" id="name" required className="w-full bg-transparent border-b border-cream/20 py-3 text-cream focus:outline-none focus:border-accent transition-colors placeholder:text-cream/30" placeholder="Jane Doe" data-id="element-60" />
                  </div>
                  <div data-id="element-61">
                    <label htmlFor="email" className="block text-sm font-medium text-cream/70 mb-2" data-id="element-62">
                      Email
                    </label>
                    <input type="email" id="email" required className="w-full bg-transparent border-b border-cream/20 py-3 text-cream focus:outline-none focus:border-accent transition-colors placeholder:text-cream/30" placeholder="jane@company.com" data-id="element-63" />
                  </div>
                  <div data-id="element-64">
                    <label htmlFor="message" className="block text-sm font-medium text-cream/70 mb-2" data-id="element-65">
                      Project Details
                    </label>
                    <textarea id="message" required rows={4} className="w-full bg-transparent border-b border-cream/20 py-3 text-cream focus:outline-none focus:border-accent transition-colors placeholder:text-cream/30 resize-none" placeholder="Tell me about your timeline, budget, and goals..." data-id="element-66" />
                  </div>
                  <button type="submit" disabled={formState === 'submitting'} className="w-full bg-accent text-cream py-4 rounded-full font-medium hover:bg-white hover:text-ink transition-colors duration-300 disabled:opacity-70 disabled:cursor-not-allowed flex justify-center items-center gap-2" data-id="element-67">
                    {formState === 'submitting' ? <>
                        <svg className="animate-spin h-5 w-5 text-cream" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-68">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-69"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-70"></path>
                        </svg>
                        Sending...
                      </> : 'Send Message'}
                  </button>
                </form>}
            </div>
          </div>
        </div>
      </div>
    </section>;
}